import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../services";
import { Dropdown, Menu, Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Logo from "./logo";
import LanguageSwitcher from "../components/languageSwitcher";
import { useLocalization } from "../context/localization";
import '../index.css';

const Navbar = () => {
    const [menuItems, setMenuItems] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const { language } = useLocalization();

    useEffect(() => {
        const fetchMenuData = async () => {
            try {
                const response = await api.general.getSections(language);
                setMenuItems(response.data.data);
            } catch (error) {
                console.error('Error fetching menu data:', error);
            }
        };
        fetchMenuData();
    }, [language]);

    const renderMenuItems = subItems => subItems?.map(subItem => ({
        key: subItem.id,
        label: <Link to={subItem.slug}>{subItem.name}</Link>,
        disabled: subItem.disabled || false,
    }));

    return (
        <div className="navbar">
            <Logo/>

            <div className="hamburger-container">
                <Button
                    className="hamburger-button"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <MenuOutlined style={{ fontSize: '20px'}}/>
                </Button>

                <LanguageSwitcher/>

            </div>

            <Drawer
                placement="right"
                onClose={() => setIsOpen(false)}
                visible={isOpen}
            >
                <Menu
                    mode="inline"
                    items={menuItems.map(item => ({
                        key: item.id,
                        label: <Link style={{ color: "black"}} onClick={(e) => e.stopPropagation()}
                                     to={item.attributes.Slug}>{item.attributes.Heading}</Link>,
                        children: item.attributes.Links.map(link => ({
                            key: link.id,
                            label: <Link to={link.slug}>{link.name}</Link>
                        }))
                    }))}
                />
            </Drawer>

            <ul className="nav-list">
                {menuItems?.map((item) => (
                    <li key={item.id}>
                        {item.attributes.Links.length > 0 ? (
                            <Dropdown
                                overlay={<Menu items={renderMenuItems(item.attributes.Links)}/>}
                                trigger={['hover']}
                                overlayClassName="custom-dropdown-menu"
                            >
                                <Link onClick={(e) => e.stopPropagation()}
                                      to={item.attributes.Slug}>{item.attributes.Heading}</Link>
                            </Dropdown>
                        ) : (
                            <Link to={item.attributes.Slug}>{item.attributes.Heading}</Link>
                        )}
                    </li>
                ))}
                <LanguageSwitcher/>
            </ul>
        </div>
    );
};

export default Navbar;
